import { SET_ENTITLEMENTS_INFO } from '../actions/entilementsActions';

export function entilementsReducer(prevState : any = [], action : any = {}) {
    switch (action.type) {
        case SET_ENTITLEMENTS_INFO:
            return action.entitlements;
        default:
            return prevState;
    }
}
